/**
 * Eigen velden (custom fields) in Model Info of Fan info (Jordy 07-10-2026, punt 5).
 *
 * Opslag: `_custom_fields` = [{label, value}], in de volgorde van de lijst.
 * Zo kan een label en de volgorde worden aangepast zonder dat de sleutel van
 * een veld verandert. Het opslaan voegt samen op de server; deze lijst gaat
 * altijd als geheel mee.
 */
export interface EigenVeld { label: string; value: string }

export function eigenVeldenUit(info: Record<string, unknown> | null | undefined): EigenVeld[] {
  const lijst = (info ?? {})._custom_fields
  if (!Array.isArray(lijst)) return []
  return lijst
    .filter((c): c is Record<string, unknown> => !!c && typeof c === 'object')
    .map((c) => ({ label: String(c.label ?? ''), value: String(c.value ?? '') }))
}

export default function EigenVelden({ velden, onChange }: {
  velden: EigenVeld[]
  onChange: (v: EigenVeld[]) => void
}) {
  const zet = (i: number, deel: Partial<EigenVeld>) =>
    onChange(velden.map((v, j) => (j === i ? { ...v, ...deel } : v)))
  const schuif = (i: number, d: -1 | 1) => {
    const j = i + d
    if (j < 0 || j >= velden.length) return
    const n = [...velden]
    ;[n[i], n[j]] = [n[j], n[i]]
    onChange(n)
  }
  return (
    <div>
      {velden.map((v, i) => (
        <div key={i} className="row" style={{ gap: 6, marginBottom: 6, alignItems: 'center' }}>
          <input className="inp" style={{ maxWidth: 200 }} placeholder="Label" value={v.label}
                 onChange={(e) => zet(i, { label: e.target.value })} />
          <input className="inp" placeholder="Value" value={v.value}
                 onChange={(e) => zet(i, { value: e.target.value })} />
          <button className="btn ghost sm" type="button" title="Move up"
                  disabled={i === 0} onClick={() => schuif(i, -1)}>↑</button>
          <button className="btn ghost sm" type="button" title="Move down"
                  disabled={i === velden.length - 1} onClick={() => schuif(i, 1)}>↓</button>
          <button className="btn ghost sm" type="button" title="Remove field"
                  onClick={() => onChange(velden.filter((_, j) => j !== i))}>✕</button>
        </div>
      ))}
      <button className="btn ghost sm" type="button"
              onClick={() => onChange([...velden, { label: '', value: '' }])}>
        + Add custom field
      </button>
    </div>
  )
}
